// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import SocialIcon from '../../../internal/SocialIcon';
import Iframe from '../../../components/Iframe';
import logo from '../../../static/images/ansarada-logo-symbol.svg';
import StructuredDataFooter from './Internal/StructuredDataFooter';

type LinkGroupType = {|
  name: string,
  links: Array<{|
    name: string,
    href: string,
  |}>,
|};

type PropTypes = {|
  facebookHref: string,
  twitterHref: string,
  linkedInHref: string,
  legalHref: string,
  privacyHref: string,
  linkGroups: Array<LinkGroupType>,
  currentYear: number,
  pardotFormUrl: string,
|};

const LinkGroup = (props: { ...LinkGroupType, onClick: string => void, expanded: boolean }) => {
  const onClick = props.onClick.bind(null, props.name);

  return (
    <div className={cx(styles.primaryCol, { [styles.isExpanded]: props.expanded })}>
      <h2 className={styles.primaryTitle}>
        <button className={styles.mobileExpander} onClick={onClick}>
          {props.name}
        </button>
        <span className={styles.desktopTitle}>{props.name}</span>
      </h2>
      <ul className={styles.linkGroup}>
        {props.links.map((link, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li className={styles.primaryLink} key={index}>
            <a href={link.href}>{link.name}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

const Footer = (props: PropTypes) => {
  const [expanded, onExpand] = React.useState(undefined);

  const expandPanel = groupName => {
    if (expanded === groupName) {
      onExpand(undefined);
    } else {
      onExpand(groupName);
    }
  };

  return (
    <>
      <div className="footer-before" id="footer-before" />
      <footer className={styles.footer}>
        <div className={styles.container}>
          <div className={styles.primaryContainer}>
            {props.linkGroups.map((group, index) => (
              /* eslint-disable react/no-array-index-key */
              <LinkGroup
                {...group}
                onClick={expandPanel}
                expanded={expanded === group.name}
                key={index}
              />
              /* eslint-enable react/no-array-index-key */
            ))}
            <div className={`${styles.primaryCol} ${styles.inputCol}`}>
              <h2 className={styles.primaryTitle}>Subscribe to our newsletter</h2>
              <div className={styles.inputContainer}>
                <Iframe src={props.pardotFormUrl} />
              </div>
            </div>
          </div>

          <div className={styles.secondaryContainer}>
            <div className={styles.secondaryLinks}>
              <img src={logo} className={styles.logo} width="18" height="18" alt="" />
              <a className={styles.secondaryLink} href={props.legalHref}>
                Legal
              </a>
              <a className={styles.secondaryLink} href={props.privacyHref}>
                Privacy policy
              </a>
            </div>

            <div className={styles.copyright}>
              <p>{`© 2005–${props.currentYear} Ansarada Pty Ltd. All Rights Reserved`}</p>
            </div>

            <ul className={styles.social}>
              <li className={styles.socialLink}>
                <SocialIcon href={props.facebookHref} type="Facebook" color="Grey" />
              </li>
              <li className={styles.socialLink}>
                <SocialIcon href={props.linkedInHref} type="LinkedIn" color="Grey" />
              </li>
              <li className={styles.socialLink}>
                <SocialIcon href={props.twitterHref} type="Twitter" color="Grey" />
              </li>
            </ul>
          </div>
        </div>
        <StructuredDataFooter />
      </footer>
    </>
  );
};

export default Footer;
